<template>
  <div id="WFM" class="ACD18 text-NotoSansRegular mx-auto">
    <div class="banner relative mb-2 md:mb-3">
      <div class="max-w-5xl mx-auto relative">
        <img src="~@/assets/images/202108/banner.jpg" class="object-contain max-w-full w-full hidden md:block">
        <img src="~@/assets/images/202108/banner_m.jpg" class="object-contain max-w-full w-full md:hidden">
        <div class="banner-logo absolute">
          <router-link :to="{ name: 'index' }">
            <img src="~@/assets/images/202108/logo_white.png" class="object-contain max-w-full w-full">
          </router-link>
        </div>
      </div>
      <div class="btns flex justify-center w-full flex-wrap">
        <div class="w-1/2 md:w-auto p-1 md:p-2">
          <a class="btn cursor-pointer font-normal text-NotoSansRegular py-2 px-8 text-center md:w-auto block whitespace-no-wrap" @click="toreadTogether">親子共讀
          </a>
        </div>
        <div class="w-1/2 md:w-auto p-1 md:p-2">
          <a class="btn cursor-pointer font-normal text-NotoSansRegular py-2 px-8 text-center md:w-auto block whitespace-no-wrap" @click="towfh"
            >WFH專區
          </a>
        </div>
        <div class="w-1/2 md:w-auto p-1 md:p-2">
          <a class="btn cursor-pointer font-normal text-NotoSansRegular py-2 px-8 text-center md:w-auto block whitespace-no-wrap" @click="toonlineLearn">線上學習
          </a>
        </div>
        <div class="w-1/2 md:w-auto p-1 md:p-2">
          <a class="btn cursor-pointer font-normal text-NotoSansRegular py-2 px-8 text-center md:w-auto block whitespace-no-wrap" @click="toschoolBook">國高中用書
          </a>
        </div>
      </div>

    </div>
    <div class="readTogether px-2" id="readTogether">
      <div class="max-w-5xl mx-auto">
        <div class="flex w-full flex-col md:flex-row">
          <div>
            <img src="~@/assets/images/202108/topic1-1.png" class="object-contain w-full h-auto">
          </div>
          <div>
            <img src="~@/assets/images/202108/topic1-2.png" class="object-contain w-full h-auto">
          </div>
        </div>
        <div class="items flex flex-wrap p-2">
          <div class="item w-1/2 md:w-1/4 p-2" v-for="(item, index) in readTogether" :key="index">
            <router-link :to="{ name: 'detail', params: { category: item.type, id: item.id } }" target="_blank">
              <img :src="item.img_url" class="good object-contain w-full h-auto mx-auto">
              <div class="index-img absolute">
                <img :src="item.index_url" class="object-contain w-full h-auto mx-auto">
              </div>
            </router-link>
          </div>
        </div>
        <div class="more py-8 md:py-12">
          <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: 108 } }">
            <img src="~@/assets/images/202108/more.png" class="object-contain max-w-full mx-auto hover:shadow-lg">
          </router-link>
        </div>
      </div>
    </div>
    <div class="wfh px-2" id="wfh">
      <div class="max-w-5xl mx-auto">
        <div class="flex w-full flex-col md:flex-row">
          <div>
            <img src="~@/assets/images/202108/topic2-1.png" class="object-contain w-full h-auto">
          </div>
          <div>
            <img src="~@/assets/images/202108/topic2-2.png" class="object-contain w-full h-auto">
          </div>
        </div>
        <div class="items flex flex-wrap p-2">
          <div class="item w-1/2 md:w-1/4 p-2" v-for="(item, index) in wfh" :key="index">
            <router-link :to="{ name: 'detail', params: { category: item.type, id: item.id } }" target="_blank">
              <img :src="item.img_url" class="good object-contain w-full h-auto mx-auto">
              <div class="index-img absolute">
                <img :src="item.index_url" class="object-contain w-full h-auto mx-auto">
              </div>
            </router-link>
          </div>
        </div>
        <div class="more py-8 md:py-12">
          <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: 103 } }" target="_blank">
            <img src="~@/assets/images/202108/more.png" class="object-contain max-w-full mx-auto hover:shadow-lg">
          </router-link>
        </div>
      </div>
    </div>
    <div class="onlineLearn px-2" id="onlineLearn">
      <div class="max-w-5xl mx-auto">
        <div class="flex w-full flex-col md:flex-row">
          <div>
            <img src="~@/assets/images/202108/topic3-1.png" class="object-contain w-full h-auto">
          </div>
          <div>
            <img src="~@/assets/images/202108/topic3-2.png" class="object-contain w-full h-auto">
          </div>
        </div>
        <div class="items flex flex-wrap p-2">
          <div class="item w-1/2 md:w-1/4 p-2" v-for="(item, index) in onlineLearn" :key="index">
            <router-link :to="{ name: 'detail', params: { category: item.type, id: item.id } }" target="_blank">
              <img :src="item.img_url" class="good object-contain w-full h-auto mx-auto">
              <div class="index-img absolute">
                <img :src="item.index_url" class="object-contain w-full h-auto mx-auto">
              </div>
            </router-link>
          </div>
        </div>
        <div class="more py-8 md:py-12">
          <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK,DIGITAL' } }" target="_blank">
            <img src="~@/assets/images/202108/more.png" class="object-contain max-w-full mx-auto hover:shadow-lg">
          </router-link>
        </div>
      </div>
    </div>
    <div class="schoolBook px-2" id="schoolBook">
      <div class="max-w-5xl mx-auto">
        <div class="flex w-full flex-col md:flex-row">
          <div>
            <img src="~@/assets/images/202108/topic4-1.png" class="object-contain w-full h-auto">
          </div>
          <div>
            <img src="~@/assets/images/202108/topic4-2.png" class="object-contain w-full h-auto">
          </div>
        </div>
        <div class="items flex flex-wrap p-2">
          <div class="item w-1/2 md:w-1/4 p-2" v-for="(item, index) in schoolBook" :key="index">
            <router-link :to="{ name: 'detail', params: { category: item.type, id: item.id } }" target="_blank">
              <img :src="item.img_url" class="good object-contain w-full h-auto mx-auto">
              <div class="index-img absolute">
                <img :src="item.index_url" class="object-contain w-full h-auto mx-auto">
              </div>
            </router-link>
          </div>
        </div>
        <div class="more py-8 md:py-12">
          <router-link :to="{ name: 'productsList', params: { category: 'book' }, query: { type: 'BOOK', category: 113 } }" target="_blank">
            <img src="~@/assets/images/202108/more.png" class="object-contain max-w-full mx-auto hover:shadow-lg">
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jump from 'jump.js'
export default {
  name: 'event202108',
  metaInfo () {
    return {
      title: '學習不喊卡! LivwABC陪你宅在家',
      titleTemplate: null
    }
  },
  data () {
    return {
      readTogether: [
        { id: 7100, type: 'book', img_url: require('@/assets/images/202108/item/1-1.png'), index_url: require('@/assets/images/202108/number/no1.png') },
        { id: 7089, type: 'book', img_url: require('@/assets/images/202108/item/1-2.png'), index_url: require('@/assets/images/202108/number/no2.png') },
        { id: 7088, type: 'book', img_url: require('@/assets/images/202108/item/1-3.png'), index_url: require('@/assets/images/202108/number/no3.png') },
        { id: 7067, type: 'package', img_url: require('@/assets/images/202108/item/1-4.png'), index_url: require('@/assets/images/202108/number/no4.png') },
        { id: 7068, type: 'package', img_url: require('@/assets/images/202108/item/1-5.png'), index_url: require('@/assets/images/202108/number/no5.png') },
        { id: 6592, type: 'package', img_url: require('@/assets/images/202108/item/1-6.png'), index_url: require('@/assets/images/202108/number/no6.png') },
        { id: 6555, type: 'package', img_url: require('@/assets/images/202108/item/1-7.png'), index_url: require('@/assets/images/202108/number/no7.png') },
        { id: 6591, type: 'package', img_url: require('@/assets/images/202108/item/1-8.png'), index_url: require('@/assets/images/202108/number/no8.png') }
      ],
      wfh: [
        { id: 7137, type: 'book', img_url: require('@/assets/images/202108/item/2-1.png'), index_url: require('@/assets/images/202108/number/no1.png') },
        { id: 7236, type: 'book', img_url: require('@/assets/images/202108/item/2-2.png'), index_url: require('@/assets/images/202108/number/no2.png') },
        { id: 6936, type: 'book', img_url: require('@/assets/images/202108/item/2-3.png'), index_url: require('@/assets/images/202108/number/no3.png') },
        { id: 6835, type: 'book', img_url: require('@/assets/images/202108/item/2-4.png'), index_url: require('@/assets/images/202108/number/no4.png') },
        { id: 6146, type: 'package', img_url: require('@/assets/images/202108/item/2-5.png'), index_url: require('@/assets/images/202108/number/no5.png') },
        { id: 7138, type: 'book', img_url: require('@/assets/images/202108/item/2-6.png'), index_url: require('@/assets/images/202108/number/no6.png') },
        { id: 6871, type: 'book', img_url: require('@/assets/images/202108/item/2-7.png'), index_url: require('@/assets/images/202108/number/no7.png') },
        { id: 6217, type: 'book', img_url: require('@/assets/images/202108/item/2-8.png'), index_url: require('@/assets/images/202108/number/no8.png') }
      ],
      onlineLearn: [
        { id: 6786, type: 'package', img_url: require('@/assets/images/202108/item/3-1.png'), index_url: require('@/assets/images/202108/number/no1.png') },
        { id: 6787, type: 'package', img_url: require('@/assets/images/202108/item/3-2.png'), index_url: require('@/assets/images/202108/number/no2.png') },
        { id: 7237, type: 'book', img_url: require('@/assets/images/202108/item/3-3.png'), index_url: require('@/assets/images/202108/number/no3.png') },
        { id: 7239, type: 'book', img_url: require('@/assets/images/202108/item/3-4.png'), index_url: require('@/assets/images/202108/number/no4.png') },
        { id: 6791, type: 'book', img_url: require('@/assets/images/202108/item/3-5.png'), index_url: require('@/assets/images/202108/number/no5.png') },
        { id: 7141, type: 'book', img_url: require('@/assets/images/202108/item/3-6.png'), index_url: require('@/assets/images/202108/number/no6.png') },
        { id: 7037, type: 'book', img_url: require('@/assets/images/202108/item/3-7.png'), index_url: require('@/assets/images/202108/number/no7.png') },
        { id: 7040, type: 'book', img_url: require('@/assets/images/202108/item/3-8.png'), index_url: require('@/assets/images/202108/number/no8.png') }
      ],
      schoolBook: [
        { id: 7207, type: 'book', img_url: require('@/assets/images/202108/item/4-1.png'), index_url: require('@/assets/images/202108/number/no1.png') },
        { id: 6570, type: 'book', img_url: require('@/assets/images/202108/item/4-2.png'), index_url: require('@/assets/images/202108/number/no2.png') },
        { id: 6757, type: 'book', img_url: require('@/assets/images/202108/item/4-3.png'), index_url: require('@/assets/images/202108/number/no3.png') },
        { id: 7218, type: 'book', img_url: require('@/assets/images/202108/item/4-4.png'), index_url: require('@/assets/images/202108/number/no4.png') },
        { id: 6610, type: 'book', img_url: require('@/assets/images/202108/item/4-5.png'), index_url: require('@/assets/images/202108/number/no5.png') },
        { id: 6393, type: 'book', img_url: require('@/assets/images/202108/item/4-6.png'), index_url: require('@/assets/images/202108/number/no6.png') },
        { id: 6355, type: 'book', img_url: require('@/assets/images/202108/item/4-7.png'), index_url: require('@/assets/images/202108/number/no7.png') },
        { id: 6611, type: 'book', img_url: require('@/assets/images/202108/item/4-8.png'), index_url: require('@/assets/images/202108/number/no8.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toreadTogether () {
      jump('#readTogether', {
        duration: 600,
        offset: 0
      })
    },
    towfh () {
      jump('#wfh', {
        duration: 800,
        offset: 0
      })
    },
    toonlineLearn () {
      jump('#onlineLearn', {
        duration: 900,
        offset: 0
      })
    },
    toschoolBook () {
      jump('#schoolBook', {
        duration: 1000,
        offset: 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  $main-first: #97B2FF;
  $main-second: #A6BDFF;
  $main-third: #C5D4FF;
  $main-fourth: #DAE4FF;

  #WFM {
    .banner {
      background-color: $main-first;
      margin-bottom: 5px;
      .btns {
        position: absolute;
        bottom: 0%;
        left: 50%;
        transform: translateX(-50%);
        @media (min-width: 1024px) {
          position: absolute;
          bottom: 2%;
          left: 50%;
          transform: translateX(-50%);
        }
        .btn {
          color: #EFEFEF;
          background-color: #2B2B2B;
          border: 1px solid #EFEFEF;
          font-size: 18px;
          &:hover {
            background-color: #FFFC25;
            border: 1px solid #2B2B2B;
            color: #2B2B2B;
          }
        }
      }
      .banner-logo {
        width: 80px;
        right: 20px;
        top: 20px;
        @media (min-width: 768px) {
          width: 100px;
        }
      }
    }

    .readTogether {
      background-color: $main-first;
      .items {
        background-color: #ffffff;
      }
    }
    .wfh {
      background-color: $main-second;
      .items {
        background-color: #ffffff;
      }
    }
    .onlineLearn {
      background-color: $main-third;
      .items {
        background-color: #ffffff;
      }
    }
    .schoolBook {
      background-color: $main-fourth;
      .items {
        background-color: #ffffff;
      }
    }
    .item {
      position: relative;
      transition: .3s;
      &:nth-child(1), &:nth-child(3), &:nth-child(5), &:nth-child(7) {
        &:after {
          position: absolute;
          content: '';
          height: 100%;
          width: 2px;
          background-image: linear-gradient(to bottom, #A6A6A6 0%, #A6A6A6 70%, transparent 50%);
          background-size: 100% 18px;
          background-repeat: repeat-y;
          top: 0;
          right: 0;
        }
      }
      &:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(5), &:nth-child(6) {
        &:before {
          position: absolute;
          content: '';
          height: 2px;
          width: 100%;
          background-image: linear-gradient(to right, #A6A6A6 0%, #A6A6A6 70%, transparent 50%);
          background-size: 18px 100%;
          background-repeat: repeat-x;
          bottom: 0;
          left: 0;
        }
      }
      @media (min-width: 768px) {
        &:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(6), &:nth-child(7) {
          &:after {
            position: absolute;
            content: '';
            height: 100%;
            width: 2px;
            background-image: linear-gradient(to bottom, #A6A6A6 0%, #A6A6A6 70%, transparent 50%);
            background-size: 100% 18px;
            background-repeat: repeat-y;
            top: 0;
            right: 0;
          }
        }
        &:nth-child(4) {
          &:after {
            position: absolute;
            content: '';
            height: 100%;
            width: 2px;
            background-image: linear-gradient(to bottom, #A6A6A6 0%, #A6A6A6 0%, transparent 0%);
            background-size: 100% 18px;
            background-repeat: repeat-y;
            top: 0;
            right: 0;
          }
        }
        &:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(5), &:nth-child(6) {
          &:before {
            position: absolute;
            content: '';
            height: 2px;
            width: 100%;
            background-image: linear-gradient(to right, #A6A6A6 0%, #A6A6A6 70%, transparent 50%);
            background-size: 18px 100%;
            background-repeat: repeat-x;
            bottom: 0;
            left: 0;
          }
        }
        &:nth-child(5), &:nth-child(6) {
          &:before {
            position: absolute;
            content: '';
            height: 2px;
            width: 100%;
            background-image: linear-gradient(to right, #A6A6A6 0%, #A6A6A6 0%, transparent 0%);
            background-size: 18px 100%;
            background-repeat: repeat-x;
            bottom: 0;
            left: 0;
          }
        }
      }
      &:hover {
        // transform: translateY(-0.5em);
        .good {
          transition: .3s;
          transform: translateY(-0.5em);
        }
      }
      // border-bottom: 2px solid #A6A6A6;
      // border-style: dashed;
      // &:after {
      //   position: absolute;
      //   content: '';
      //   height: 100%;
      //   width: 2px;
      //   background-image: linear-gradient(to bottom, #A6A6A6 0%, #A6A6A6 70%, transparent 50%);
      //   background-size: 100% 18px;
      //   background-repeat: repeat-y;
      //   top: 0;
      //   right: 0;
      // }

      // &:nth-child(odd) {
      //   border-right: 2px solid #A6A6A6;
      //   border-style: dashed;
      // }
      // &:nth-child(7), &:nth-child(8) {
      //   border-bottom: 2px solid #ffffff;
      // }
      // @media (min-width: 768px) {
      //   border-right: 2px solid #A6A6A6;
      //   border-style: dashed;
      //   &:nth-child(4), &:nth-child(8) {
      //     border-right: 2px solid #ffffff;
      //   }
      //   &:nth-child(5), &:nth-child(6) {
      //     border-bottom: 2px solid #ffffff;
      //   }
      // }
      .index-img {
        left: -1em;
        top: -1.2em;
      }
    }
  }
</style>
